var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShipment(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 44.507,
    viewBox: "0 0 48 44.507",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:rgba(11,183,167,0.4);}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M39.111,19.336V4.043A3.547,3.547,0,0,0,35.569.5H3.543A3.547,3.547,0,0,0,0,4.043V36.069a3.547,3.547,0,0,0,3.543,3.543H24.167A13.194,13.194,0,1,0,39.111,19.336ZM16.077,3.384h6.958v7.96l-2.944-1.176a1.445,1.445,0,0,0-1.07,0l-2.944,1.176ZM3.543,36.727a.66.66,0,0,1-.659-.659V4.043a.66.66,0,0,1,.659-.659h9.65V13.473a1.442,1.442,0,0,0,1.977,1.339l4.386-1.752,4.386,1.752a1.442,1.442,0,0,0,1.977-1.339V3.384h9.65a.66.66,0,0,1,.659.659V18.691a13.2,13.2,0,0,0-13.67,18.037Zm31.261,5.4A10.313,10.313,0,1,1,45.116,31.81,10.324,10.324,0,0,1,34.8,42.123Zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M361.62,268.437h-3.9v-3.9a1.442,1.442,0,1,0-2.884,0v5.347a1.442,1.442,0,0,0,1.442,1.442h5.347a1.442,1.442,0,1,0,0-2.884Zm0,0",
    transform: "translate(-321.567 -237.972)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipment);
export default __webpack_public_path__ + "static/media/shipment.7e3d1523226d4335184d05596f01dfbf.svg";
export { ForwardRef as ReactComponent };